export default __webpack_public_path__ + "static/media/Logo.2723d958.svg";